var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"cols":_vm.cols,"lg":_vm.lg}},[_c('fakeInput')],1)}
var staticRenderFns = []

export { render, staticRenderFns }